module.exports = __webpack_public_path__ + "img/los-postigos-verdes.328c8e57.jpg";